import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, WrapperData } from 'modules/theme';
import { ControlLabel } from 'modules/theme';
import { ChartWrapper, FlexRow, InsightContent, InsightRow, InsightTitle } from '../styles/main';
import DashboardTileTheme from './DashboardTileTheme';
import { FiPhone } from 'react-icons/fi';
import { Line } from 'react-chartjs-2';

export class DashboardTheme extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // endDate: currentTimestamp,
      // startDate: dayBeforeTimeStamp,
      // selectedProjects: [],
      // columnList: defaultColums,
      // selectedColumList: selectedColumList,
      reportData: [],
      totalPerPage: 0,
      perPageCount: 10,
      currentPage: 1,
      loading: true,
      dashboardTile: [
        { title: 'Agent', count: 0, isSecs: false, icon: <FiPhone style={{fontSize: "15px"}} /> },
        { title: 'Drop', count: 0, isSecs: false, icon: <FiPhone style={{fontSize: "15px"}} /> },
        { title: 'Missed', count: 0, isSecs: false, icon: <FiPhone style={{fontSize: "15px"}} /> },
        { title: 'Total', count: 0, isSecs: false, icon: <FiPhone style={{fontSize: "15px"}} /> }
      ],
      dashboardSentGraph: this.generateGraph({
        labels: ["25 Apr","26 Apr","27 Apr","28 Apr","29 Apr","30 Apr"],
        data : [
          {
            label: 'Answered',
            data: [33, 25, 35, 51, 54, 76],
            backgroundColor: ["rgb(229, 221, 244)"],
            borderColor: "#673AB7"
          },
          {
            label: 'Drop',
            data: [10, 5, 8, 2, 8, 2],
            backgroundColor: "#90CAF9",
            borderColor: "#90CAF9"
          },
          {
            label: 'Missed',
            labels: ["25 Apr","26 Apr","27 Apr","28 Apr","29 Apr","30 Apr"],
            backgroundColor: "#FFAB91",
            borderColor: "#FFAB91"
          }
        ]
      }),
    };
    this.handleFireAPI();
  }

  handleFireAPI() {
    this.setState({ loading: true });
    console.log(`Dashboard URL ->`);
  }

  generateGraph(cData) {
    let tData = {
      labels: cData.labels,
      plot: {
        animation: {
          sequence: 3,
          effect: 4,
          method: 1,
          speed: 500
        }
      },
      datasets: []
    };
    if ( cData.data ){
      cData.data.forEach(element => {
        let datasets = {
          label: element.label || "none",
          fill: true,
          lineTension: element.lineTension || 0.1,
          backgroundColor: element.backgroundColor || [
            'rgb(26, 35, 126)',
            'rgb(48, 63, 159)',
            'rgb(63, 81, 181)',
            'rgb(121, 134, 203)',
            'rgb(197, 202, 233)',
            'rgb(232, 234, 246)'
          ],
          borderColor: element.borderColor || [
            'rgb(26, 35, 126)',
            'rgb(48, 63, 159)',
            'rgb(63, 81, 181)',
            'rgb(121, 134, 203)',
            'rgb(197, 202, 233)',
            'rgb(232, 234, 246)'
          ],
          borderCapStyle: element.borderCapStyle || 'butt',
          borderDash: element.borderDash || [],
          borderDashOffset: element.borderDashOffset || 0.0,
          borderJoinStyle: element.borderJoinStyle || 'miter',
          pointBorderColor: element.pointBorderColor || '#4D528E',
          pointBackgroundColor: element.pointBackgroundColor || '#fff',
          pointBorderWidth: element.pointBorderWidth || 1,
          pointHoverRadius: element.pointHoverRadius || 5,
          pointHoverBackgroundColor: element.pointHoverBackgroundColor || '#4D528E',
          pointHoverBorderColor: element.pointHoverBorderColor || '#4D528E',
          pointHoverBorderWidth: element.pointHoverBorderWidth || 2,
          pointRadius: element.pointRadius || 1,
          pointHitRadius: element.pointHitRadius || 10,
          data: element.data || []
        }
        tData.datasets.push(datasets);
      });
    }
    return tData;
  }

  renderTitle(title) {
    const { __ } = this.context;
    return (
      <InsightTitle>
        {__(title)}
      </InsightTitle>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [{ title: __('Dashboard'), link: '/dashboard' }];

    const options = {
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ],
        yAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ]
      }
    };

    const content = (
      <div>
        <InsightContent>
          <InsightRow className="summ">
            <DashboardTileTheme
              loading={false}
              data={this.state.dashboardTile}
              options={options}
            />
          </InsightRow>
          <InsightRow style={{ marginTop: '20px' }}>
            <FlexRow>
              <ChartWrapper>
                {this.renderTitle('Calls')}
                <Line
                  ref="chart"
                  height={50}
                  data={this.state.dashboardSentGraph}
                  options={options}
                />
              </ChartWrapper>
            </FlexRow>
          </InsightRow>
        </InsightContent>
      </div>
    );
    return (
      <div>
        <WrapperData
          header={<Wrapper.Header breadcrumb={breadcrumb} />}
          content={content}
          style={{ overflow: "hidden" }}
          transparent={true}
        />
      </div>
    );
  }
}

DashboardTheme.contextTypes = {
  __: PropTypes.func
};

export default DashboardTheme;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/DashboardTheme.js